import { isRequired } from "utils/redux-form";

export const requiredIfIvrCompany = (value, formValues) => {
  if (formValues && formValues.ivr_company) return isRequired(value);
};

export const isValidIvrEndTime = (value, formValues) => {
  if (formValues && formValues.ivr_start > value) return "Invalid end time";
};

export const isValidOutreachEndTime = (value, formValues) => {
  if (formValues && formValues.outreach_start_time > value)
    return "Invalid end time";
};

export const isValidOfficeEndTime = (value, formValues) => {
  if (formValues && formValues.office_hours_start > value)
    return "Invalid end time";
};

export const isValidCustomReminderDays = value => {
  if (value < 2 || value > 29) return "reminder days must be between 2-29";
};

export const isValidCustomPreorderDays = value => {
  if ((value < 0 || value > 7) && value != null && value != "")
    return "preorder days must be between 0-7";
};

export const isValidTopicDuration = value => {
  if (value == null || value === "") return;
  else if (value < 15 || value > 255 || value % 15 !== 0)
    return "Invalid topic duration";
};

export const required = value => (value ? undefined : "Required");
